import React, { useEffect, useState } from 'react'
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { toast } from 'react-toastify';
import { Dialog } from 'primereact/dialog';
import { useSelector } from 'react-redux';
import { selectCurrentEmpid, selectCurrentUserManagerLevel } from '../../../pages/login/authSlice';
import { changeDateFormate, datetimeToDate } from '../../../utils/dateFormat';
import { AGENTROLE, MANAGERROLE, ROLES, SUPERVISORROLE } from '../../../constants';
import CoachingToDo from '../../../components/CoachingToDo/CoachingToDo';
import { useCoachingGoalSettingMutation } from '../goals/goalSlice';
import { CascadeGaolSetting } from './CascadeGoalSetting';
import './revgen.scss'
import DescriptionBox from '../../../components/descriptionBox/DescriptionBox';

interface RevgenGoalSettingProps {
    data: any;
    recipientDetails: any;
    setExpandedRows: (params: any) => void;
    hideControls: boolean;
    isSupervisorReviewed: boolean;
    isAssociateAcknowledged: boolean;
    inputMonth: number;
    inputYear: number;
    viewState?: string;
}

export const findAuthorRole = (level: string) => {
    if (ROLES.Agents?.includes(level)) return AGENTROLE.charAt(0).toUpperCase() + AGENTROLE.slice(1);
    else if (ROLES.Supervisor?.includes(level))
        return SUPERVISORROLE.charAt(0).toUpperCase() + SUPERVISORROLE.slice(1);
    else if (ROLES.Manager?.includes(level))
        return MANAGERROLE.charAt(0).toUpperCase() + MANAGERROLE.slice(1);
    else return '';
};

export const RevgenGoalSetting = (props: RevgenGoalSettingProps) => {
    const [authorGoalDesc, setAuthorGoalDesc] = useState<string>(props.data?.goal_description || '');
    const [associateGoalDesc, setAssociateGoalDesc] = useState<string>('');
    const [target, setTarget] = useState<string>(props.data?.target_goal_value || '');
    const [visible, setVisible] = useState<boolean>(false);
    const [dialogVisible, setDialogVisible] = useState(false);
    const [uncheckDialog, setUncheckDialog] = useState(false);
    const userManagerLevel = useSelector(selectCurrentUserManagerLevel);

    const openUncheckDialog = () => {
        setUncheckDialog(true);
    }


    const openDialog = () => {
        setDialogVisible(true);
    };

    const [CoachingGoalSetting] = useCoachingGoalSettingMutation();
    const loggedEmpNum = useSelector(selectCurrentEmpid);

    useEffect(() => {
        setAssociateGoalDesc(props.data?.response_description || '');
    }, []);

    const handleSave = () => {
        if (authorGoalDesc.length < 10) {
            toast.warn('Sorry, but the Author Goal Description must be greater than 10 characters.');
            return;
        }
        if (associateGoalDesc.length !== 0 && associateGoalDesc.length < 10) {
            toast.warn('Sorry, but the Associate Goal Description must be greater than 10 characters.');
            return;
        }
        const payload: any = {
            coachingGoalId: props.data?.coaching_goal_id,
            goalDescription: authorGoalDesc,
            responseDescription: associateGoalDesc,
            targetGoalValue: target ? target.toString() : '',
        };
        if ((props.data?.response_description !== (associateGoalDesc === "" ? null : associateGoalDesc))
            || (props.data?.target_goal_value !== (target === "" ? null : target))) {
            payload.responseEmployeeNumber = loggedEmpNum;
            payload.responseDate = datetimeToDate(Date.now());
        }
        CoachingGoalSetting(payload)
            .unwrap()
            .then((res: any) => {
                if (res?.data) {
                    toast.success('Goal setting saved successfully');
                } else {
                    toast.error('Failed to save goal setting');
                }
            })
            .catch(() => {
                toast.error('Failed to save goal setting');
            });
    };
    const handleTextChange = (e: any, type: 'author' | 'associate') => {
        const eventVal = e.target.value;
        if (type === 'author') setAuthorGoalDesc(eventVal);
        else if (type === 'associate') setAssociateGoalDesc(eventVal);
    };

    const createFooterTemplate = (
        <div className="row">
            <div className="col-md-2">&nbsp;</div>
            <div className="col-md-4">
                <Button
                    className="btn-secondary me-2"
                    onClick={() => { setUncheckDialog(false) }}
                    label={'Cancel'}
                />
            </div>
            <div className="col-md-4">
                <Button className="btn-primary w-100"
                    onClick={() => {
                        setUncheckDialog(false);
                        openDialog()
                    }} label={'Yes'} />
            </div>
            <div className="col-md-2">&nbsp;</div>
        </div>
    );

    return (
        <>
            <div className='supervisor-manager-input-bg padding-5-10'>
                <div className="align-center d-flex justify-content-between mt-2">
                    <h6 className='color-purple'>Goal Coaching</h6>
                    <hr className='color-purple width-75 border-2' />
                    <h6 className='color-purple'>Beginning of the Month</h6>
                </div>
                <DescriptionBox
                    value={authorGoalDesc}
                    responseDescription={authorGoalDesc}
                    readOnly={props.isSupervisorReviewed || props.hideControls}
                    limit={1000}
                    onChange={(value) => {
                        const syntheticEvent = {
                            target: { value },
                        };
                        handleTextChange(syntheticEvent, 'author');
                    }}
                />
                <div className="d-flex justify-content-start mt-3">
                    <div className="me-4">
                        <h6>Date</h6>
                        <div >
                            {changeDateFormate(datetimeToDate(props.data.goal_date))}
                        </div>
                    </div>
                    <div className="me-4">
                        <h6>Author</h6>
                        {props.data.author_employee_name}
                    </div>
                </div>

            </div>

            <div className='associate-bg padding-5-10'>
                <div className="align-center d-flex justify-content-between">
                    <h6 className='color-purple'>Associate Goal Setting</h6>
                    <hr className='color-purple width-70 border-2' />
                    <h6 className='color-purple'>Beginning of the Month</h6>
                </div>
                <DescriptionBox
                    value={associateGoalDesc}
                    responseDescription={associateGoalDesc}
                    readOnly={props.isAssociateAcknowledged || props.hideControls}
                    limit={1000}
                    onChange={(value) => {
                        const syntheticEvent = {
                            target: { value },
                        };
                        handleTextChange(syntheticEvent, 'associate');
                    }}
                />
                <div className="d-flex justify-content-start mt-3">
                    <div className="me-4">
                        <h6>Date</h6>
                        <div className="mt-3">
                            {props.data?.response_date !== null ? changeDateFormate(datetimeToDate(props.data.response_date)) : ''}
                        </div>
                    </div>
                    <div className="me-4">
                        <h6>Target</h6>
                        <InputText
                            className="borderRadius8  me-4 associate-bg"
                            value={target}
                            disabled={props.isAssociateAcknowledged || props.hideControls}
                            onChange={(e) => setTarget(e.target.value)}
                            maxLength={20}
                        />
                        <div className="d-flex justify-content-end textSmall lightText me-4">{`${target.length}/20 character limit`}</div>
                    </div>
                </div>
            </div>


            <div className='float-end mt-2'>
                <div className='col-md-5' style={{ display: "flex", justifyContent: "space-evenly", alignItems: "center" }}>
                    <Button
                        label="Cancel"
                        style={{ fontWeight: 400 }}
                        className="btn-secondary me-2"
                        onClick={() => { props.setExpandedRows(null) }}
                    />
                    {ROLES.SupervisorORManager.includes(userManagerLevel) && <Button
                        label="Cascade"
                        disabled={props.viewState === 'read-only'}
                        onClick={() => {
                            if (props.isAssociateAcknowledged || props.isSupervisorReviewed) {
                                openUncheckDialog();
                            } else {
                                openDialog()
                            }
                        }}
                        className="btn-primary me-2"
                    />}

                    <Button
                        label="Save"
                        disabled={props.hideControls}
                        onClick={handleSave}
                        className="btn-primary me-2"
                    />
                    <CoachingToDo
                        receiverId={props.recipientDetails.employeeNumber}
                        receiverName={props.recipientDetails.employeeName}
                        visible={visible}
                        setVisible={setVisible}
                        coachingEntityTypeId={5}
                        coachingEntityId={props.data.coaching_goal_id}
                        coachingStatusId={1}
                    />
                    {dialogVisible && <CascadeGaolSetting inputMonth={props.inputMonth} inputYear={props.inputYear} goalDeatails={props.data} visible={dialogVisible} setVisible={setDialogVisible} />}

                    {uncheckDialog && <Dialog header='Cascading Goals' footer={createFooterTemplate} visible={uncheckDialog} style={{ width: '50vw' }} onHide={() => setUncheckDialog(false)}>
                        <div className='dialog-body'>
                            <div className='dialog-title'>
                                <p style={{
                                    color: "#404D61",
                                    fontSize: "14PX",
                                    fontStyle: "normal",
                                    fontWeight: "500",
                                    marginBottom: "0px",
                                    width: "40%"
                                }}>All review boxes will be unchecked.</p>
                            </div>
                        </div>
                    </Dialog>}
                </div>
            </div>
        </>
    )
}